<app-page-content>
<app-doenkids-menu-bar menuBar> </app-doenkids-menu-bar>
<div content>
  <div class="message">
    @if (brandParams$ | async; as brandParams) {
      <h1 class="title">{{ 'home.title' | translate: brandParams }}</h1>

      <h3 class="subtitle">{{ 'home.subtitle' | translate }}</h3>

      @if ((countryCode$ | async)?.toLowerCase(); as countryCode) {
        <div class="content" [innerHTML]="'home.content.intro_' + countryCode | translate: brandParams"></div>
      }
    }
  </div>

  <div class="newsfeed-container flex-col">
    <div class="news-header flex-row justify-between items-center" style="width: 100%;">
      <h3>{{ 'home.news_items.title' | translate }}</h3>
      <mat-slide-toggle [formControl]="unreadItemsOnlyControl">{{ 'home.news_items.unread_only_toggle' | translate }}</mat-slide-toggle>
    </div>

    <div class="newsfeed-wrapper">
      <app-newsfeed [hideReadItems]="unreadItemsOnly" (doneLoading)="doneLoading()" #newsFeed></app-newsfeed>
    </div>
  </div>

</div>
<div fixed>
<router-outlet></router-outlet>
</div>
</app-page-content>
